import { Navigate, Route } from 'react-router'

/** Beleggers (spec-45) and Skybox (spec-46) were removed in spec-59; old
 *  deeplinks land on the Relaties start page instead of an empty outlet. */
export const removedCrmRoutes = [
  <Route key="beleggers" path="beleggers/*" element={<Navigate to="/relaties" replace />} />,
  <Route key="skybox" path="skybox/*" element={<Navigate to="/relaties" replace />} />,
]
